import React from "react";
import { PRIVACY_URL, TERMS_URL } from "../../data/landing";
import { arrowClass, CTA_MICROCOPY, primaryButtonClass } from "../../utils/buttonStyles";
import type { Contact, ContactErrors } from "./useApplicationWizard";
type WizardContactFormProps = {
  contact: Contact;
  errors: ContactErrors;
  onChange: <K extends keyof Contact>(field: K, value: Contact[K]) => void;
  onSubmit: () => void;
};
type TextField = {
  key: "name" | "phone" | "email";
  label: string;
  type: string;
  autoComplete: string;
  inputMode?: "email" | "tel" | "text";
  fullWidth?: boolean;
};
const fields: TextField[] = [{
  key: "name",
  label: "Nombre",
  type: "text",
  autoComplete: "name",
  fullWidth: true
}, {
  key: "phone",
  label: "Teléfono",
  type: "tel",
  autoComplete: "tel",
  inputMode: "tel"
}, {
  key: "email",
  label: "Email",
  type: "email",
  autoComplete: "email",
  inputMode: "email"
}];
export function WizardContactForm({
  contact,
  errors,
  onChange,
  onSubmit
}: WizardContactFormProps) {
  return <form noValidate onSubmit={e => {
    e.preventDefault();
    onSubmit();
  }} data-id="element-41" data-mp="20es09ri3y324">
      <h3 className="font-display text-[24px] uppercase leading-[1.05] tracking-[-0.01em] text-cream sm:text-[30px]" data-id="element-42" data-mp="1vmqqcc8ewof9">
        ¿A quién le enviamos tu diagnóstico?
      </h3>
      <p className="mt-3 text-[15px] text-muted" data-id="element-43" data-mp="1mnn7n9d5qb1a">Te toma 20 segundos. No compartimos tus datos.</p>

      <div className="mt-8 grid gap-5 sm:grid-cols-2" data-id="element-44" data-mp="2jdw66recrgpk">
        {fields.map(f => {
        const error = errors[f.key];
        const id = `field-${f.key}`;
        return <div key={f.key} className={f.fullWidth ? "sm:col-span-2" : ""} data-id="element-45" data-mp="2acfvsjnjfelc">
              <label htmlFor={id} className="block font-ui text-[12px] font-bold uppercase tracking-[0.14em] text-muted" data-id="element-46" data-mp="2aeix3zu54u5d">
                {f.label} <span className="text-gold" aria-hidden="true" data-id="element-47" data-mp="yyu8l418nn2g">*</span>
              </label>
              <input id={id} type={f.type} inputMode={f.inputMode} autoComplete={f.autoComplete} required value={contact[f.key]} onChange={e => onChange(f.key, e.target.value)} aria-invalid={Boolean(error)} aria-describedby={error ? `${id}-error` : undefined} className={`mt-2 h-12 w-full rounded-[3px] border bg-ink px-4 text-[16px] text-cream transition-colors duration-150 ease-out focus:outline-none focus:ring-1 focus:ring-gold ${error ? "border-red-400/60" : "border-steel focus:border-gold"}`} data-id="element-48" data-mp="twv6dxh8iw73" />
              {error && <p id={`${id}-error`} className="mt-1.5 text-[14px] text-red-300" data-id="element-49" data-mp="7q0vgeri56c8">
                  {error}
                </p>}
            </div>;
      })}
      </div>

      <div className="mt-7 border-t border-line pt-6" data-id="element-50" data-mp="3uuqpv7akmp1t">
        <label className="flex cursor-pointer gap-3" data-id="element-51" data-mp="3uu77xqkx80ns">
          <input type="checkbox" checked={contact.consent} onChange={e => onChange("consent", e.target.checked)} aria-invalid={Boolean(errors.consent)} aria-describedby={errors.consent ? "consent-error" : undefined} className="mt-1 h-4 w-4 shrink-0 cursor-pointer rounded-sm accent-[#FFB700]" data-id="element-52" data-mp="3b8otrsznbqfn" />
          <span className="text-[14px] leading-relaxed text-muted" data-id="element-53" data-mp="3gae7xhi60k7y">
            Acepto recibir llamadas, mensajes de texto y emails de Studio Web VIP sobre
            mi solicitud. Pueden aplicar tarifas de mensajes y datos. Responde STOP para
            cancelar.{" "}
            <a href={PRIVACY_URL} target="_blank" rel="noopener noreferrer" className="text-cream underline decoration-gold/70 underline-offset-2 hover:text-gold" data-id="element-54" data-mp="7rgglmfv5er9">
              Política de Privacidad
            </a>{" "}
            ·{" "}
            <a href={TERMS_URL} target="_blank" rel="noopener noreferrer" className="text-cream underline decoration-gold/70 underline-offset-2 hover:text-gold" data-id="element-55" data-mp="cp87qe8oowue">
              Términos
            </a>
          </span>
        </label>
        {errors.consent && <p id="consent-error" className="mt-1.5 pl-7 text-[14px] text-red-300" data-id="element-56" data-mp="2kyofpbi3kpij">
            {errors.consent}
          </p>}
      </div>

      <div className="mt-8 flex flex-col gap-3" data-id="element-57" data-mp="1ncqrcxh1dpyo">
        <button type="submit" className={`${primaryButtonClass} w-full`} data-id="element-58" data-mp="1sa0pr2melbyn">
          Enviar mi solicitud
          <span className={arrowClass} aria-hidden="true" data-id="element-59" data-mp="1x9ls7n0s82g4">
            →
          </span>
        </button>
        <p className="text-center text-[14px] text-muted" data-id="element-60" data-mp="21bgrklz5k5r9">{CTA_MICROCOPY}</p>
      </div>
    </form>;
}